import type { JSX } from 'react';
import type { WireArtifact } from '@logistics/contracts';
import { BoardArtifact } from './board-artifact';
import { CalendarArtifact } from './calendar-artifact';
import { ChartArtifact } from './chart-artifact';
import { ChatArtifact } from './chat-artifact';
import { CustomersArtifact } from './customers-artifact';
import { DocArtifact } from './doc-artifact';
import { DriverArtifact } from './driver-artifact';
import { EmailArtifact } from './email-artifact';
import { HosArtifact } from './hos-artifact';
import { KpiArtifact } from './kpi-artifact';
import { LoadArtifact } from './load-artifact';
import { MapArtifact } from './map-artifact';
import { MoneyArtifact } from './money-artifact';
import { RankingArtifact } from './ranking-artifact';
import { TableArtifact } from './table-artifact';
import { TimelineArtifact } from './timeline-artifact';
import { VehicleArtifact } from './vehicle-artifact';

type Body<K extends WireArtifact['kind']> = (
  artifact: Extract<WireArtifact, { kind: K }>,
) => JSX.Element;

/** One renderer per kind. Every provider string is rendered as text; none is HTML. */
const BODIES: { readonly [K in WireArtifact['kind']]: Body<K> } = {
  load: (artifact) => <LoadArtifact artifact={artifact} />,
  map: (artifact) => <MapArtifact artifact={artifact} />,
  hos: (artifact) => <HosArtifact artifact={artifact} />,
  timeline: (artifact) => <TimelineArtifact artifact={artifact} />,
  table: (artifact) => <TableArtifact artifact={artifact} />,
  email: (artifact) => <EmailArtifact artifact={artifact} />,
  doc: (artifact) => <DocArtifact artifact={artifact} />,
  chart: (artifact) => <ChartArtifact artifact={artifact} />,
  money: (artifact) => <MoneyArtifact artifact={artifact} />,
  board: (artifact) => <BoardArtifact artifact={artifact} />,
  customers: (artifact) => <CustomersArtifact artifact={artifact} />,
  calendar: (artifact) => <CalendarArtifact artifact={artifact} />,
  ranking: (artifact) => <RankingArtifact artifact={artifact} />,
  kpi: (artifact) => <KpiArtifact artifact={artifact} />,
  chat: (artifact) => <ChatArtifact artifact={artifact} />,
  vehicle: (artifact) => <VehicleArtifact artifact={artifact} />,
  driver: (artifact) => <DriverArtifact artifact={artifact} />,
};

export function ArtifactBody({ artifact }: { artifact: WireArtifact }): JSX.Element {
  return (BODIES[artifact.kind] as Body<WireArtifact['kind']>)(artifact);
}
